import { useEffect,useState } from "react";
import { OnBoardStep } from "../types/onboard";
import { getApplicationSummaryApi } from "../api/application";
import { useApiError } from "../provider/ApiErrorProvider";
import { handleApiError } from "../api/handleApiError";
import { ISummaryResponse } from "../types/api/application.type";

interface CustomerDetailsHookProps {
  customerId: string | undefined;
  currentStep:OnBoardStep
}

export function useCustomerSummary({
  customerId,
  currentStep
}: CustomerDetailsHookProps) {
  const [summary,setSummary] = useState<ISummaryResponse | undefined>(undefined);
  const {setError} = useApiError();
  useEffect(() => {
    const fetchCustomerDetails = async () => {
      if ((currentStep === OnBoardStep.RESULTS) && customerId) {
        try{
          const response = await getApplicationSummaryApi(customerId);
          if(response?.status == 200){
            setError(null)
            setSummary(response?.data);
          }
        }
        catch(error){
          handleApiError(error,setError,() => fetchCustomerDetails());
        }
      }
    };
    fetchCustomerDetails();
  }, [customerId, currentStep]);
  return {
    summary
  };
}
